import { useTranslation } from "react-i18next";
import { Box, Paper, Typography, useTheme } from "@mui/material";
import { faBuilding } from "@fortawesome/pro-regular-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import type { OverviewSensorCounts } from "@core/apis/shared";

type OverviewHeaderProps = Readonly<{
  address: string;
  sensorCounts: OverviewSensorCounts;
  isLoading: boolean;
}>;

export function OverviewHeader({ address, sensorCounts, isLoading }: OverviewHeaderProps) {
  const { t } = useTranslation(["propai_properties", "propai"]);
  const theme = useTheme();

  if (!address && !isLoading && sensorCounts.sensorCount === 0) {
    return null;
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        backgroundColor: theme.palette.background.default,
        borderRadius: 2,
        px: 2,
        py: 3,
      }}
      component={Paper}
      elevation={1}
    >
      <Box display="flex" alignItems="center" gap={1}>
        <FontAwesomeIcon icon={faBuilding} size="lg" />
        <Typography variant="titleLarge">{address}</Typography>
      </Box>
      {!isLoading && (
        <Box>
          <Typography variant="labelLarge">
            <strong>{sensorCounts.sensorCount}</strong>{" "}
            {t("overview_sensors_text", { ns: "propai" })} |{" "}
            <strong>{sensorCounts.activeSensorCount}</strong>{" "}
            {t("overview_sensors_with_data_text", { ns: "propai" })}
          </Typography>
        </Box>
      )}
    </Box>
  );
}
